/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetExpensePosition = {
    Rent: 'Rent',
    HomeOwnership: 'HomeOwnership',
    Energy: 'Energy',
    Heating: 'Heating',
    Phone: 'Phone',
    Broadcasting: 'Broadcasting',
    Childcare: 'Childcare',
    PublicTransport: 'PublicTransport',
    HouseholdInsurance: 'HouseholdInsurance',
    LifeInsurance: 'LifeInsurance',
    OtherInsurance: 'OtherInsurance',
    Vehicles: 'Vehicles',
    VehicleInsuranceAndTax: 'VehicleInsuranceAndTax',
    Fuel: 'Fuel',
    Parking: 'Parking',
    LivingCosts: 'LivingCosts',
    Other: 'Other'
} as const;
export type AssetExpensePosition = typeof AssetExpensePosition[keyof typeof AssetExpensePosition];


export function instanceOfAssetExpensePosition(value: any): boolean {
    for (const key in AssetExpensePosition) {
        if (Object.prototype.hasOwnProperty.call(AssetExpensePosition, key)) {
            if (AssetExpensePosition[key as keyof typeof AssetExpensePosition] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetExpensePositionFromJSON(json: any): AssetExpensePosition {
    return AssetExpensePositionFromJSONTyped(json, false);
}

export function AssetExpensePositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetExpensePosition {
    return json as AssetExpensePosition;
}

export function AssetExpensePositionToJSON(value?: AssetExpensePosition | null): any {
    return value as any;
}

export function AssetExpensePositionToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetExpensePosition {
    return value as AssetExpensePosition;
}

